import { render, staticRenderFns } from "./DiscordAuthorize.vue?vue&type=template&id=d3ab384e&scoped=true"
import script from "./DiscordAuthorize.vue?vue&type=script&lang=js"
export * from "./DiscordAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ab384e",
  null
  
)

export default component.exports